import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upArrow",
  "use": "icon-upArrow-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 18\" id=\"icon-upArrow\">\r\n  <image id=\"icon-upArrow_上升\" width=\"10\" height=\"18\" xlink:href=\"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAeUlEQVQoke3PMQrCQBBA0adYpwq2KWzSBOy8hOAhckU7xd5UaT2KVSSwgU3cFQtLB4aFz9tiVkNVWUyNAY84rxfogDs67HOwwRlF2EtoMziGG8roYxlaM8E6gWJ8xW6ExwyaZotT6uo+vNljPs4f/gZuEu35LWzfCl4I7A+MZFQpmwAAAABJRU5ErkJggg==\"></image>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol